import { Link } from 'react-router-dom';
import { marketPrices } from '@/mocks/marketPrices';
import { useState, useMemo } from 'react';

export default function MarketPriceSection() {
  const [activeVariety, setActiveVariety] = useState('全部');

  const varieties = useMemo(() => {
    const all = ['全部'];
    marketPrices.forEach((mp) => {
      if (!all.includes(mp.variety)) all.push(mp.variety);
    });
    return all;
  }, []);

  const filteredPrices = useMemo(() => {
    if (activeVariety === '全部') return marketPrices;
    return marketPrices.filter((mp) => mp.variety === activeVariety);
  }, [activeVariety]);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2">
              全国市场行情
            </h2>
            <p className="text-foreground-500 text-sm">
              实时更新全国主要批发市场黄瓜价格
            </p>
          </div>
          <Link
            to="/category/shichang-hangqing"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看更多行情
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="flex items-center gap-2 mb-5 flex-wrap">
          {varieties.map((v) => (
            <button
              key={v}
              onClick={() => setActiveVariety(v)}
              className={`px-4 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
                activeVariety === v
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700'
              }`}
            >
              {v}
            </button>
          ))}
        </div>

        <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-100 text-left">
                  <th className="px-4 py-3 font-medium text-foreground-600 whitespace-nowrap text-xs">批发市场</th>
                  <th className="px-4 py-3 font-medium text-foreground-600 whitespace-nowrap text-xs">省份</th>
                  <th className="px-4 py-3 font-medium text-foreground-600 whitespace-nowrap text-xs">品种</th>
                  <th className="px-4 py-3 font-medium text-foreground-600 whitespace-nowrap text-xs text-right">价格（元/公斤）</th>
                  <th className="px-4 py-3 font-medium text-foreground-600 whitespace-nowrap text-xs text-right">涨跌</th>
                  <th className="px-4 py-3 font-medium text-foreground-600 whitespace-nowrap text-xs">更新日期</th>
                </tr>
              </thead>
              <tbody>
                {filteredPrices.map((mp) => (
                  <tr key={mp.id} className="border-t border-background-200 hover:bg-primary-50/30 transition-colors">
                    <td className="px-4 py-3 text-foreground-800 font-medium text-xs whitespace-nowrap">{mp.market}</td>
                    <td className="px-4 py-3 text-foreground-500 text-xs whitespace-nowrap">{mp.province}</td>
                    <td className="px-4 py-3 text-xs whitespace-nowrap">
                      <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-md text-[10px] font-medium">
                        {mp.variety}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-right text-foreground-800 font-semibold text-xs whitespace-nowrap">{mp.price.toFixed(1)}</td>
                    <td className={`px-4 py-3 text-right text-xs font-medium whitespace-nowrap ${
                      mp.change > 0 ? 'text-accent-600' : mp.change < 0 ? 'text-primary-600' : 'text-foreground-400'
                    }`}>
                      {mp.change > 0 ? '+' : ''}{mp.change.toFixed(1)}
                    </td>
                    <td className="px-4 py-3 text-foreground-400 text-xs whitespace-nowrap">{mp.updateDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <p className="text-xs text-foreground-400 mt-3">
          数据更新时间：2026年8月7日 · 数据来源：全国农产品批发市场价格信息系统
        </p>
      </div>
    </section>
  );
}